import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToPricing = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 relative overflow-hidden bg-brand-pink" data-id="element-34">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-pink to-brand-pink-deep" data-id="element-35"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-37">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-brand-black mb-6" data-id="element-38">
            EL MOMENTO ES AHORA
          </h2>

          <p className="text-xl md:text-2xl text-brand-black/80 font-medium mb-10" data-id="element-39">
            La inflación no espera y los huecos en tu agenda tampoco. Hacé clic
            abajo y transformá tu estética en una empresa hoy mismo.
          </p>

          <button onClick={scrollToPricing} className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-5 text-lg font-bold text-white bg-brand-black rounded-full hover:bg-gray-900 hover:scale-105 transition-all duration-300 shadow-xl" data-id="element-40">
            👇 VER OPCIONES DE PAGO — ACCESO INSTANTÁNEO
          </button>
        </motion.div>
      </div>
    </section>;
}